var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOffline = function SvgOffline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    viewBox: "0 0 278 213"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 82867"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h278v213H0z",
    "data-name": "Rectangle 30783"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "No Internet"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c7d4ff",
    d: "M191.53 140.76c9.335 4.113-5.869 4.621-26.294 6.239-20.426 1.664-31.978.185-47.182-.046-15.157-.231-37.616.832-39.141-3.7-1.571-4.529 11.137-7.579 12.292-10.12 1.109-2.5-26.988-1.109-26.294-4.02a4.6 4.6 0 0 1 2.541-2.634c12.385-6.885 66.037-7.533 92.147-7.717 29.113-.231 59.29-.647 71.3 6.239 1.618.924 2.311 1.71 2.264 2.4-.185 4.529-30.685 4.76-39.788 6.193-10.625 1.621-11.179 3.054-1.845 7.166",
    "data-name": "Path 48722"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99adf9",
    d: "M177.852 133.181c6.885 2.68-4.344 2.957-19.409 4.02-15.111 1.016-23.66.092-34.844-.093-11.229-.185-27.773.508-28.928-2.449s8.226-4.9 9.058-6.516-19.963-.739-19.455-2.68a3.23 3.23 0 0 1 1.849-1.71c9.15-4.436 48.8-4.76 68.07-4.9 21.488-.139 48.568-1.571 52.681 2.819 1.987 2.126-20.98 5.961-27.727 6.839-7.811 1.065-8.227 1.989-1.295 4.67",
    "data-name": "Path 48723"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99adf9",
    d: "M191.53 140.76c9.335 4.113-5.869 4.621-26.294 6.239-20.426 1.664-31.978.185-47.182-.046-15.157-.231-37.616.832-39.141-3.7-1.571-4.529 11.137-7.579 12.292-10.12 1.109-2.5-26.988-1.109-26.294-4.02a4.6 4.6 0 0 1 2.541-2.634c.37.693 1.849 1.386 5.961 1.71 9.381.693 22.644 1.2 23.429 3.189s-13.032 7.44-11.276 10.213c1.756 2.726 38.957 1.617 61.184 2.4s42.007-.647 39.465-2.172-8.734-4.9-4.067-7.948 30.407-3.558 41.267-4.621a45 45 0 0 0 9.7-1.849c-.185 4.529-30.684 4.76-39.788 6.193-10.577 1.621-11.131 3.054-1.797 7.166",
    "data-name": "Path 48724"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99adf9",
    d: "M216.67 124.077c-2.819.231-2.588 3 2.218 2.357 4.76-.6 3.281-2.819-2.218-2.357",
    "data-name": "Path 48725"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99adf9",
    d: "M199.988 126.157c-2.819.231-2.588 3 2.218 2.357 4.805-.555 3.281-2.819-2.218-2.357",
    "data-name": "Path 48726"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99adf9",
    d: "M78.589 125.001c-2.819.231-2.588 3 2.218 2.357 4.806-.554 3.281-2.772-2.218-2.357",
    "data-name": "Path 48727"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99adf9",
    d: "M93.654 134.565c-2.819.231-2.588 3 2.218 2.357 4.76-.598 3.281-2.816-2.218-2.357",
    "data-name": "Path 48728"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7d4ff",
    d: "M242.683 138.449c-3.189 2.172-8.087 2.634-15.342 2.726-5.222.092-8.179-1.571-7.81-3.189.277-1.2 2.449-2.357 6.886-2.819 8.272-.832 15.85.185 16.867 1.8.328.466.143.974-.601 1.482",
    "data-name": "Path 48729"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7d4ff",
    d: "M86.216 118.209c-3.836 2.218-9.843 2.819-18.808 3.1-6.423.185-10.12-1.386-9.658-3 .324-1.2 2.958-2.449 8.41-2.958 10.12-1.016 19.5-.185 20.842 1.433.368.408.137.87-.786 1.425",
    "data-name": "Path 48730"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7d4ff",
    d: "M233.214 49.768s6.285-.647 13.263 8.411a22.64 22.64 0 0 1 4.3 15.712s4.252-8.78-1.479-16.96c-6.151-8.734-16.084-7.163-16.084-7.163",
    "data-name": "Path 48731"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7d4ff",
    d: "M229.883 78.004a15.15 15.15 0 0 1 .092 9.427c-1.571 5.545-4.529 7.856-4.529 7.856a9.96 9.96 0 0 0 6.608-7.625c1.345-6.238-2.171-9.658-2.171-9.658",
    "data-name": "Path 48732"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99adf9",
    d: "M96.473 82.256s-.647-3.6 4.436-10.4a29.57 29.57 0 0 1 12.477-9.381l-8.965-18.531s3.374 12.986-1.571 16.867c-4.991 3.882-13.217-1.109-13.217-1.109s4.9 8.6 3.327 12.385c-1.525 3.789-9.843 4.436-9.843 4.436Z",
    "data-name": "Path 48733"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99adf9",
    d: "m125.078 155.548-5.545 6.655a1.64 1.64 0 0 1-2.5-2.126l.185-.185 6.562-5.684a.937.937 0 0 1 1.294.092.974.974 0 0 1 .004 1.248",
    "data-name": "Path 48734"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99adf9",
    d: "m132.795 156.334-1.109 13.494a1.368 1.368 0 0 1-2.726-.231v-.046l1.8-13.448a1.07 1.07 0 0 1 1.155-.878 1.05 1.05 0 0 1 .88 1.109",
    "data-name": "Path 48735"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99adf9",
    d: "m140.697 155.825 3.651 9.566a1.639 1.639 0 0 1-3.05 1.2.35.35 0 0 1-.046-.231l-2.311-9.982a.94.94 0 0 1 .693-1.109.91.91 0 0 1 1.063.556",
    "data-name": "Path 48736"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99adf9",
    d: "m148.138 154.3 5.5 3.7a1.634 1.634 0 0 1-1.8 2.726 1 1 0 0 1-.231-.185l-4.763-4.619a.98.98 0 0 1 0-1.433.946.946 0 0 1 1.294-.189",
    "data-name": "Path 48737"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec272",
    d: "M244.952 85.121c-2.727 8.5-14.649 12.847-14.649 12.847l.37-.37c1.71-1.941 8.78-10.906 2.726-22.551-6.839-13.217-29.437-8.688-29.437-8.688l-.508-3.281-.555-3.42s12.292-10.952 28.882-4.714c15.805 5.962 15.897 21.72 13.171 30.177",
    "data-name": "Path 48738"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcaa51",
    d: "M236.172 92.515a17.4 17.4 0 0 1-5.453 5.083c1.71-1.941 8.78-10.906 2.726-22.551-6.839-13.217-29.437-8.688-29.437-8.688l-.508-3.281c4.9-.693 17.838-1.8 26.618 3.281 10.444 6.054 10.398 19.363 6.054 26.156",
    "data-name": "Path 48739"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec272",
    d: "M207.936 76.757c-.231 7.348-1.432 13.725-3.1 17.422-3.559 8.041-6.054 12.616-11.276 16.683a46 46 0 0 1-7.163 4.482c-10.675 5.592-39.742 5.961-39.742 5.961a86 86 0 0 1-3.466.231c-10.582.555-20.564-.6-26.71-3.928a11.43 11.43 0 0 1-5.776-6.054c-2.912-8.5-3.974-21.488 15.342-54.391 12.434-21.168 27.957-29.529 42.657-29.437a42.6 42.6 0 0 1 22.089 6.654c.277.185.6.37.878.555 13.033 8.411 16.733 27.08 16.267 41.822",
    "data-name": "Path 48740"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffcb8d",
    d: "M168.702 27.68c-8.688 3.512-22.043 12.246-34.151 33.966-15.389 27.588-17.791 47.968-18.115 55.916a11.43 11.43 0 0 1-5.776-6.054c-2.911-8.5-3.974-21.488 15.342-54.391 12.521-21.165 28.051-29.53 42.7-29.437",
    "data-name": "Path 48741"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcaa51",
    d: "M207.936 76.757c-.231 7.348-1.433 13.725-3.1 17.422-4.9 11-7.764 15.527-18.439 21.119s-39.742 5.961-39.742 5.961c-1.155.092-2.31.185-3.466.231-.324-4.39.786-10.305 3.374-18.023 7.856-23.568 20.333-32.256 34.428-34.982 12.157-2.311 21.631 3.604 26.945 8.272",
    "data-name": "Path 48742"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcaa51",
    d: "M207.936 76.756c-.231 7.348-1.432 13.725-3.1 17.422-3.558 8.041-6.054 12.616-11.276 16.683a113 113 0 0 0 6.608-36.184c.324-19.686-5.129-33.042-9.381-40.3.277.185.6.37.878.555 13.036 8.415 16.733 27.083 16.271 41.824",
    "data-name": "Path 48743"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec272",
    d: "M208.167 80.176c-.739 8.642-4.344 22.505-7.717 31.7a38.4 38.4 0 0 1-3.743 8.133c-1.849 2.634-5.453 3.789-9.058 4.02-3.789.277-7.625-.37-9.381-1.34-3.235-1.71-11.276-16.451-9.473-32.533q.139-1.456.416-2.911c3.235-17.145 11.276-21.951 23.476-20.61a33.7 33.7 0 0 1 7.3 1.525c4.899 1.761 8.827 5.084 8.18 12.016",
    "data-name": "Path 48744"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcaa51",
    d: "M200.449 111.877a38.4 38.4 0 0 1-3.743 8.133c-3.789 5.407-14.973 4.529-18.439 2.726-3.235-1.71-11.276-16.451-9.473-32.533 1.017 7.44 4.714 17.884 17.052 20.564a44.7 44.7 0 0 0 14.603 1.11",
    "data-name": "Path 48745"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcaa51",
    d: "M208.167 80.176c-.74 8.642-4.344 22.505-7.717 31.7a38.4 38.4 0 0 1-3.743 8.133c-1.849 2.634-5.453 3.789-9.058 4.02 3.651-6.562 12.061-24.446 12.477-49.4.046-2.218 0-4.39-.092-6.47 4.852 1.758 8.782 5.085 8.133 12.017",
    "data-name": "Path 48746"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec272",
    d: "M196.382 126.11a12.4 12.4 0 0 1-1.849.231c-.6.046-1.248.139-1.987.185-1.386.092-2.958.185-4.575.231-.647 0-1.34.046-1.987.046-1.386.046-2.726 0-3.974 0h-.509c-.508 0-1.016-.046-1.432-.046-.185 0-.37-.046-.509-.046a10 10 0 0 1-1.71-.277c-2.819-.878-4.529-3.651-2.357-7.024s6.885-6.054 13.124-6.054 11.46 3.651 11.738 7.579c.279 3.881-1.061 4.621-3.973 5.175",
    "data-name": "Path 48747"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffa245",
    d: "M188.019 120.611v6.146c-.647 0-1.34.046-1.987.046v-6.193a1.017 1.017 0 0 1 .97-1.016 1.06 1.06 0 0 1 1.017 1.017",
    "data-name": "Path 48748"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffa245",
    d: "M182.104 120.705v6.1h-.508c-.508 0-1.017-.046-1.433-.046v-6.008a1.074 1.074 0 0 1 .97-1.109 1 1 0 0 1 .971 1.063",
    "data-name": "Path 48749"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffa245",
    d: "M194.58 120.611v5.73c-.6.046-1.248.139-1.987.185v-5.915a1.017 1.017 0 0 1 .97-1.016 1.06 1.06 0 0 1 1.017 1.016",
    "data-name": "Path 48750"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff8d76",
    d: "M118.654 90.02c-3.789 7.948-1.063 27.265-3.789 33.226s-10.12 9.011-17.7 8.873a10.4 10.4 0 0 1-2.4-.323c-6.377-1.571-10.906-8.642-7.348-17.006 3.974-9.381 13.4-14.094 17.329-28 3.558-12.477 8.549-14.7 13.632-15.25a3.01 3.01 0 0 1 3.374 1.895c1.524 3.368-.325 10.854-3.098 16.585",
    "data-name": "Path 48751"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc7059",
    d: "M118.655 90.023c-3.789 7.948-1.063 27.265-3.789 33.226s-10.12 9.011-17.7 8.873a10.4 10.4 0 0 1-2.4-.323c-1.017-2.357-1.433-5.869-.092-10.952 3.373-12.754 9.889-15.158 11.091-24.123 1.248-8.965 1.386-14.511 4.621-19.363 2.911-4.344 9.843-4.066 11.368-3.928 1.526 3.369-.326 10.856-3.099 16.59",
    "data-name": "Path 48752"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff8d76",
    d: "M179.238 116.222a10.9 10.9 0 0 1-2.4 4.067c-4.159 4.529-11.738 6.007-16.174 5.268-5.545-.924-11-12.061-10.444-20.333s-5.407-19.132-6.885-24.538c-1.109-4.02-.924-7.07.277-8.919a4.64 4.64 0 0 1 1.617-1.525c1.525-.786 7.163-3.235 13.032 5.545 5.823 8.826 5.407 13.54 11.923 20.056 6.512 6.562 11.503 12.662 9.054 20.379",
    "data-name": "Path 48753"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc7059",
    d: "M176.882 120.289c-4.159 4.529-11.738 6.007-16.174 5.268-5.545-.924-11-12.061-10.444-20.333s-5.407-19.132-6.885-24.538c-1.109-4.02-.924-7.07.277-8.919 3.512-.509 9.058.046 11.645 7.3 3.974 11.045 3.42 16.729 9.566 22.135s11.229 11.276 12.015 18.993Z",
    "data-name": "Path 48754"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec272",
    d: "M169.164 123.847c-.6 5.083-3.281 8.5-9.427 10.675-9.2 3.235-17.745-1.063-21.119-1.617-3.466-.6-8.688 2.726-13.956 4.575-5.268 1.895-15.158 2.588-20.426-2.634a17.4 17.4 0 0 1-4.9-10.814 16.58 16.58 0 0 1 2.726-10.721c4.714-7.024 7.209-13.91 7.949-27.45s11.275-18.993 21.4-19.871c3.189-.277 12.061-.739 18.808 5.222 6.793 5.961 6.239 18.161 8.549 24.123s8.549 9.612 10.028 19.779a32 32 0 0 1 .368 8.733",
    "data-name": "Path 48755"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcaa51",
    d: "M142.777 115.898c-1.34 3.651-4.621 6.285-6.839 6.285s-6.516-2.126-8.6-4.067c-2.218-2.08-2.357-4.066-1.848-5.407a.35.35 0 0 1 .092-.185c.6-1.294 4.205-2.449 8.734-3.05 3.466-.462 7.394-.555 8.318.046a2.3 2.3 0 0 1 .647.786c.467 1.063.513 2.912-.504 5.592",
    "data-name": "Path 48756"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcaa51",
    d: "M169.164 123.846c-.6 5.083-3.281 8.5-9.427 10.675-9.2 3.235-17.745-1.063-21.119-1.617-3.466-.6-8.688 2.726-13.956 4.575-5.268 1.894-15.158 2.587-20.425-2.633a17.4 17.4 0 0 1-4.9-10.814c2.172 3.558 6.7 9.612 12.662 10.629 8.5 1.433 13.54-6.146 25.324-6.146 15.158 0 16.267 5.777 25.74.832a18.1 18.1 0 0 0 6.101-5.501",
    "data-name": "Path 48757"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc7059",
    d: "M142.5 129.115a18.5 18.5 0 0 1-.555 3.327c-.878 3.235-4.483 5.222-7.44 3.235-1.895-1.248-2.819-4.113-3.235-6.054-.231-1.155-.324-1.941-.324-1.941l5.638-6.007 6.008 4.159c-.046 0 .047 1.432-.092 3.281",
    "data-name": "Path 48758"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f45145",
    d: "M142.5 129.115a9.47 9.47 0 0 1-5.592-1.617 9.3 9.3 0 0 1-3.327 1.941 4.96 4.96 0 0 1-2.31.231c-.231-1.155-.324-1.941-.324-1.941l5.638-6.008 6.008 4.159c-.047-.046.046 1.386-.093 3.235",
    "data-name": "Path 48759"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c3177",
    d: "M118.747 123.615c-1.34 1.525 1.849 4.991 7.024 5.684 5.222.693 10.167-2.08 10.721-4.252a18.2 18.2 0 0 0 .046-5.638h-1.756s.555 4.945-3.928 6.932c-6.931 3.051-11.183-3.831-12.107-2.726",
    "data-name": "Path 48760"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c3177",
    d: "M137.371 118.44s.324 4.667 4.621 6.377c4.251 1.71 6.192.6 7.81-.139 1.756-.832 1.756-2.588 3-2.08.647.277.416 2.588-1.8 4.067-2.634 1.756-5.222 1.987-8.827 1.109s-5.545-2.5-6.007-4.483-.738-4.251-.738-4.251Z",
    "data-name": "Path 48761"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c3177",
    d: "M142.777 113.818c-1.34 3.651-4.621 6.285-6.839 6.285s-6.516-2.126-8.6-4.067c-2.218-2.08-2.357-4.066-1.848-5.407a.35.35 0 0 1 .092-.185c.6-1.294 4.205-2.449 8.734-3.05 3.466-.462 7.394-.555 8.318.046a2.3 2.3 0 0 1 .647.786c.467 1.11.513 2.912-.504 5.592",
    "data-name": "Path 48762"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0b2359",
    d: "M142.777 113.818c-1.34 3.651-4.621 6.285-6.839 6.285s-6.516-2.126-8.6-4.067c-2.218-2.08-2.357-4.066-1.848-5.407a.88.88 0 0 1 .693.37c1.109 1.2 2.08 3.789 6.1 6.054 4.066 2.264 5.915.6 7.717-1.756s2.126-6.423 3-6.978c.093-.046.139-.092.231-.092.517 1.109.563 2.911-.454 5.591",
    "data-name": "Path 48763"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c3177",
    d: "M118.886 107.765c1.863 0 3.373-2.235 3.373-4.991s-1.514-4.991-3.373-4.991-3.374 2.235-3.374 4.991 1.51 4.991 3.374 4.991",
    "data-name": "Path 48764"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c3177",
    d: "M149.13 105.341c1.853-.194 3.122-2.574 2.835-5.316s-2.022-4.806-3.875-4.612-3.123 2.574-2.835 5.316 2.02 4.806 3.875 4.612",
    "data-name": "Path 48765"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff8d76",
    d: "M116.575 87.062a11.9 11.9 0 0 0-3.466 4.852c-.555 1.34.092 1.849 1.71 1.895s4.344-1.941 5.823-4.252c1.475-2.357-1.156-5.037-4.067-2.495",
    "data-name": "Path 48766"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff8d76",
    d: "M148.92 84.104a12.9 12.9 0 0 1 4.205 4.251c.786 1.248.185 1.849-1.386 2.126-1.617.277-4.575-1.248-6.424-3.281s.327-5.131 3.605-3.096",
    "data-name": "Path 48767"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c3177",
    d: "M31.314 185.262c-2.126-.046-3.512-.139-3.743-.139a2.2 2.2 0 0 1-2.034-2.31 2.146 2.146 0 0 1 2.311-2.034c.231 0 16.313 1.664 29.575-3.789 4.9-1.987 7.625-3.789 8.133-5.222.37-1.063-.462-2.634-1.849-5.13-.462-.832-.97-1.71-1.479-2.68a8.15 8.15 0 0 1-.277-6.886c3-7.394 15.712-12.292 19.548-13.586 21.3-7.3 37.339-4.482 37.986-4.344a2.233 2.233 0 0 1 1.756 2.541 2.2 2.2 0 0 1-2.542 1.756c-.139-.046-15.666-2.727-35.814 4.205-8.78 3-15.435 7.394-16.96 11.091a3.72 3.72 0 0 0 .139 3.281c.462.878.924 1.756 1.386 2.541 1.664 2.911 3.189 5.684 2.172 8.688-.97 2.865-4.159 5.176-10.582 7.81-10.859 4.437-20.517 4.391-27.726 4.207",
    "data-name": "Path 48768"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f6ff",
    d: "M115.05 144.734c.786 1.849 2.68 3 5.823 3.559a15.65 15.65 0 0 0 7.81-.37l-.092-1.756-.647-10.259a20.9 20.9 0 0 0-8.318.832c-3.743 1.248-5.361 3.281-5.037 6.377a6.5 6.5 0 0 0 .461 1.617",
    "data-name": "Path 48769"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c2d7ef",
    d: "M127.874 135.809c-.942.06-1.534 2.834-1.32 6.2s1.15 6.039 2.093 5.98 1.534-2.834 1.32-6.2-1.149-6.039-2.093-5.98",
    "data-name": "Path 48770"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c2d7ef",
    d: "M115.05 144.734c.786 1.849 2.68 3 5.823 3.558a15.65 15.65 0 0 0 7.81-.37l-.093-1.756c-1.848-.092-4.205-.231-6.47-.462-3.234-.415-5.637-.739-7.07-.97",
    "data-name": "Path 48771"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87aacc",
    d: "m133.35 140.157-4.205.416a1.03 1.03 0 0 1-1.109-.924l-.046-.277a1.03 1.03 0 0 1 .924-1.109l4.205-.416a1.145 1.145 0 0 1 1.248 1.017 1.1 1.1 0 0 1-1.017 1.293",
    "data-name": "Path 48772"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87aacc",
    d: "m133.765 145.335-4.205.416a1.03 1.03 0 0 1-1.109-.924l-.046-.277a1.03 1.03 0 0 1 .924-1.109l4.205-.416a1.145 1.145 0 0 1 1.248 1.016 1.1 1.1 0 0 1-1.017 1.294",
    "data-name": "Path 48773"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c3177",
    d: "M245.737 184.292c-3.142-.092-30.777-1.109-38.772-11-5.407-6.7-2.218-11.229.555-15.25a62 62 0 0 0 1.895-2.865 5.07 5.07 0 0 0 .093-5.176c-.97-1.8-4.575-6.054-16.867-6.562-17.607-.786-40.435.185-40.666.231a2.174 2.174 0 1 1-.185-4.344c.231 0 23.291-1.016 41.082-.231 13.956.647 18.808 5.823 20.472 8.873a9.41 9.41 0 0 1-.139 9.427 34 34 0 0 1-2.08 3.142c-2.726 3.928-4.113 5.915-.739 10.074 5.869 7.255 27.82 9.242 35.768 9.381a2.172 2.172 0 0 1-.092 4.344.9.9 0 0 0-.325-.044",
    "data-name": "Path 48774"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f6ff",
    d: "M154.792 142.978c-.647 1.895-2.4 3.235-5.5 4.021a15.55 15.55 0 0 1-7.81.231l-.046-1.756-.184-10.259a20 20 0 0 1 8.318.139c3.836.924 5.592 2.819 5.545 5.961a6.3 6.3 0 0 1-.323 1.663",
    "data-name": "Path 48775"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c2d7ef",
    d: "M154.792 142.978c-.647 1.895-2.4 3.235-5.5 4.02a15.55 15.55 0 0 1-7.81.231l-.046-1.756c1.849-.231 4.159-.555 6.424-1.017 3.189-.6 5.5-1.108 6.932-1.478",
    "data-name": "Path 48776"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c2d7ef",
    d: "M141.499 147.315c.944-.017 1.659-2.762 1.6-6.13s-.878-6.084-1.822-6.067-1.659 2.762-1.6 6.13.878 6.085 1.822 6.067",
    "data-name": "Path 48777"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87aacc",
    d: "M141.378 140.8c.23 0 .4-.918.378-2.04s-.223-2.03-.453-2.026-.4.918-.378 2.041.223 2.029.453 2.025",
    "data-name": "Path 48778"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87aacc",
    d: "M141.378 146.069c.23 0 .4-.918.378-2.04s-.223-2.03-.453-2.025-.4.918-.378 2.04.223 2.029.453 2.025",
    "data-name": "Path 48779"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcaa51",
    d: "M112.047 142.378a8 8 0 0 1-.046 1.063 6.04 6.04 0 0 1-3.882 5.222 10.6 10.6 0 0 1-2.5.786 34.5 34.5 0 0 1-6.239.786c-.555.046-1.155.046-1.8.046h-1.34q-2.357 0-4.436-.139a36 36 0 0 1-2.634-.37c-3.42-.74-5.638-2.357-6.054-5.545.277 2.357-4.714-12.985 14.372-14.788 8.829-.879 14.559 7.67 14.559 12.939",
    "data-name": "Path 48780"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec272",
    d: "M112.047 142.377a8 8 0 0 1-.046 1.063c-1.849 2.5-6.193 3.7-14.511 3.835-6.608.139-11.923-.324-14.372-3.1.277 2.357-4.714-12.985 14.372-14.788 8.827-.827 14.557 7.722 14.557 12.99",
    "data-name": "Path 48781"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffa245",
    d: "M91.805 150.141a36 36 0 0 1-2.634-.37 37 37 0 0 1-.185-6.747c.323-3.281 1.571-3.466 1.941-2.865s.139 4.113.555 7.348c.092.921.231 1.848.323 2.634",
    "data-name": "Path 48782"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffa245",
    d: "M108.118 148.662a10.6 10.6 0 0 1-2.5.785c-.093-.878-.185-1.941-.324-3.05-.37-3.235-1.433-6.608-1.248-7.255s1.479-.786 2.542 2.357a33.8 33.8 0 0 1 1.53 7.163",
    "data-name": "Path 48783"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffa245",
    d: "M99.385 150.234c-.555.046-1.155.046-1.8.046h-1.34c0-1.248-.046-2.911-.139-4.436-.139-3-.231-4.945.693-5.13s1.895 3.143 2.311 6.654c.136 1.202.228 2.126.275 2.866",
    "data-name": "Path 48784"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcaa51",
    d: "M157.753 139.975a8 8 0 0 0 .092 1.063 5.93 5.93 0 0 0 3.928 5.13 16 16 0 0 0 2.5.786 35.5 35.5 0 0 0 6.239.693c.555 0 1.155.046 1.8.046h1.34a34 34 0 0 0 4.436-.231 23 23 0 0 0 2.634-.416c3.374-.786 5.592-2.4 5.961-5.638.6-5.453-5.73-13.863-14.557-14.6s-14.473 7.852-14.373 13.167",
    "data-name": "Path 48785"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec272",
    d: "M157.753 139.975a8 8 0 0 0 .092 1.063c1.895 2.5 6.239 3.6 14.557 3.651 6.608.046 11.923-.509 14.326-3.281.6-5.453-5.73-13.863-14.557-14.6-8.875-.743-14.518 7.852-14.418 13.167",
    "data-name": "Path 48786"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffa245",
    d: "M178.083 147.461a23 23 0 0 0 2.634-.416 34.5 34.5 0 0 0 .092-6.747c-.37-3.281-1.617-3.466-1.987-2.865-.324.6-.046 4.113-.416 7.348-.092.97-.231 1.848-.323 2.68",
    "data-name": "Path 48787"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffa245",
    d: "M161.77 146.167a16 16 0 0 0 2.5.785c.046-.878.139-1.941.277-3.05.324-3.235 1.34-6.608 1.109-7.255-.185-.647-1.479-.786-2.542 2.357a39.3 39.3 0 0 0-1.344 7.163",
    "data-name": "Path 48788"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffa245",
    d: "M170.504 147.6c.555 0 1.155.046 1.8.046h1.34c0-1.248 0-2.911.046-4.436.092-3 .139-4.945-.739-5.13-.924-.185-1.848 3.189-2.218 6.7-.137 1.202-.183 2.126-.229 2.82",
    "data-name": "Path 48789"
  })))));
};
export default SvgOffline;